import { MessageDescriptor } from 'react-intl';
import { ReactComponent as IconArrowLeft } from '@whitelabel/media/icons/small/arrow-left.svg';
import { INavItem } from '@whitelabel/helpers/types';
import { isOnServer } from '@whitelabel/helpers/utils';
import { PaymentsType } from './types';
import claimsPortalMessages from './messages/commonMsg';

export enum EnvTypes {
  DEVELOPMENT = 'development',
  LOCAL = 'local',
  STAGING = 'staging',
  PRODUCTION = 'production',
}

export const CP_ROOT = (process.env.VITE_CP_ROOT ||
  process.env.NEXT_PUBLIC_CP_ROOT ||
  process.env.REACT_APP_CP_ROOT) as 'xcover' | 'rentalcover';
export const APPLICATION_ENV = (process.env.VITE_ENV || process.env.NEXT_PUBLIC_ENV) as EnvTypes;

export const FNOL_CP_BACKEND_FLAG = 'fnol-flow-on-claims-portal-backend';
export const CLAIM_CREATION_CP_BACKEND_FLAG = 'claim-creation-on-claims-portal-backend';

export const PAYOUT_EMAIL_PARAM = 'payoutEmailParam';

export const STATUS_ACTION_REQUIRED = 'ACTION REQUIRED';

export const CLAIM_SUBMISSION_ERROR_STORAGE_KEY = 'claimSubmissionError';

export const CLAIM_CENTRE_STATUS = 'claim-centre-status';

export const buttonLabelMessage: Record<Exclude<PaymentsType, 'refund'>, MessageDescriptor> = {
  payout: claimsPortalMessages.getMyPayment,
  charge: claimsPortalMessages.payExcess,
};

export const DEFAULT_MAX_SIZE = 10240;

export const REVIEW_SECTION_NAME = 'review';
export const CLAIM_SUBMITTED_STATUS = 'claimSubmittedStatus';

const PARTNER_PATHNAME_REGEX = /amazon|united|mosaic|deliveroo|temu|rentalcars|travelcover/i;

export const getFnolFlowNavItems = (): INavItem[] => {
  const isFromMosaic = isOnServer ? false : PARTNER_PATHNAME_REGEX.test(window.location.hostname);

  return [
    {
      key: 'saveProgressButton',
      messageKey: 'saveProgressButtonLabel',
      name: 'Back to your claims',
      path: isFromMosaic ? '/make-a-claim' : '/claims',
      icon: IconArrowLeft,
      ...(isFromMosaic && { tag: 'a' as React.ElementType }),
    },
  ];
};

export const PAYMENT_FLOW_NAV_ITEMS: INavItem[] = [
  {
    key: 'claimPaymentButton',
    messageKey: 'claimPaymentButtonLabel',
    name: 'Back to your claim',
    path: '/claims/:claimReference/details',
    icon: IconArrowLeft,
  },
];

export const INCLUSIONS_AND_EXCLUSIONS_PAGES_MAP: Record<string, string> = {
  vueling: 'claim-test-vueling',
  sas: 'claim-test-sas',
  revolut: 'claim-test-revolut',
};
